"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValidateSchema = void 0;
var react_1 = require("react");
var yup = __importStar(require("yup"));
var next_intl_1 = require("next-intl");
var useValidateSchema = function (_a) {
    var fields = _a.fields, min = _a.min, max = _a.max;
    var t = (0, next_intl_1.useTranslations)('errors');
    return (0, react_1.useMemo)(function () {
        var yupFields = {};
        fields.forEach(function (field) {
            if (field.type === 'phone')
                return (yupFields[field.type] = yup
                    .string()
                    .required("".concat(t("customer.".concat(field.type, ".isRequired"))))
                    .min(8, t('phoneIsInvalid')));
            if (field.type !== 'amount' && field.type !== 'accountType') {
                return (yupFields[field.type] = yup
                    .string()
                    .required("".concat(t("".concat(field.name, ".isRequired")))));
            }
        }, []);
        return yup.object(__assign({ amount: yup
                .number()
                .min(Number(min), "".concat(t("minAmount"), " ").concat(Number(min)))
                .max(Number(max), "".concat(t("maxAmount"), " ").concat(max))
                .required(t('amountIsRequired')) }, yupFields));
    }, [fields, t, min, max]);
};
exports.useValidateSchema = useValidateSchema;
